<template>
    <!--receive detail table Edit -->
    <div id="editTable">
        <a-modal
            title="Edit Detail"
            :visible="visible"
            width="85%"
            @cancel="cancel"
        >
            <template slot="footer">
                <a-button key="submit" type="primary" :loading="btnLoading" @click="editSave">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-row type="flex" justify="start" style="margin-bottom: 10px;">
                <a-col>
                    <label>{{ $t('manual.Sku') }}:</label>
                    <a-input :placeholder="$t('publicLang.PleaseEnter')"  size="small" style="width: 120px;margin-left: 3px;" v-model="skuVal"/></a-col>
                <a-col style="margin: 0 10px">
                    <label>{{ $t('manual.Status') }}:</label>
                    <a-select style="width: 120px;margin-left: 3px;" size="small" :placeholder="$t('publicLang.PleaseSelect')" v-model="statusValue" allowClear>
                        <a-select-option v-for="item in statusSelect" :value="item.value">{{ item.value }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    <a-button type="primary" size="small" @click="SearchTableEvent">{{ $t('publicLang.Search') }}</a-button>
                </a-col>
            </a-row>
            <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                keep-source
                :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
                :edit-rules="validRules"
                ref="editTableRive"
                size="mini"
                :loading="tableLoading"
                :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column field="sku" :title="$t('batchReceive.SKU')" width="130" fixed="left"></vxe-table-column>
                <vxe-table-column field="status" :title="$t('batchReceive.Status')" width="100" fixed="left"></vxe-table-column>
                <vxe-table-column field="lineNo" :title="$t('batchReceive.Line')" width="70" fixed="left"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="asnQty" :title="$t('batchReceive.ASNQty')" width="80" fixed="left">
                    <template v-slot="{ row }">{{ row.asnQty }}</template>
                </vxe-table-column>
                <vxe-table-column field="recDate" :title="$t('batchReceive.RecDate')" width="160" :edit-render="{name: 'ADatePicker', props: {type: 'date', format: 'YYYY-MM-DD'}}" ></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="locationCode" :title="$t('batchReceive.LocationCode')" width="200" :edit-render="{autofocus: '.vxe-input--inner'}">
                    <template v-slot:edit="{ row }">
                        <a-auto-complete
                                style="width: 100%"
                                @search="handleSearch"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                size="small"
                                v-model="row.locationCode"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="item in completeData"  :key="item.locationCode">{{item.locationName}}</a-select-option>
                            </template>
                        </a-auto-complete>
                    </template>
                    <template v-slot="{ row }">{{ row.locationCode }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="recQty" :title="$t('batchReceive.RecQty')" width="120" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-input-number v-model="row.recQty"  size="small" :placeholder="$t('publicLang.PleaseEnter')" @change="recQtyChange(row)"/>
                    </template>
                    <template v-slot="{ row }">{{ row.recQty }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="recBaseQty" :title="$t('batchReceive.RecBaseQty')" width="120">
                    <template v-slot="{ row }">
                        <span>{{ recBaseQtymount(row) }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="damageQty" :title="$t('batchReceive.DamageQty')" width="120" :edit-render="{autofocus: '.vxe-input--inner'}">
                    <template v-slot:edit="{ row }">
                        <a-input-number v-model="row.damageQty"  size="small" :placeholder="$t('publicLang.PleaseEnter')" @change="damageQtyChange(row)"/>
                    </template>
                    <template v-slot="{ row }">{{ row.damageQty }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="damageBaseQty" :title="$t('batchReceive.DamageBaseQty')" width="120">
                    <template v-slot="{ row }">{{ damageBasQtymount(row) }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="holdQty" :title="$t('batchReceive.HoldQty')" width="120" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-input-number v-model="row.holdQty"  size="small" :placeholder="$t('publicLang.PleaseEnter')" @change="holdQtyChange(row)"/>
                    </template>
                    <template v-slot="{ row }">{{ row.holdQty }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="holdBaseQty" :title="$t('batchReceive.HoldBaseQty')" width="120">
                    <template v-slot="{ row }">{{ holdBaseQtymount(row) }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="remarks" :title="$t('batchReceive.Remarks')" width="150" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-input v-model="row.remarks" size="small" :placeholder="$t('publicLang.PleaseEnter')"/>
                    </template>
                    <template v-slot="{ row }">{{ row.remarks }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="productType" :title="$t('batchReceive.ProductType')" width="80"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="asnBaseQty" :title="$t('batchReceive.ASNBaseQty')" width="80"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="uom" :title="$t('batchReceive.UOM')" width="80"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="packageQty" :title="$t('batchReceive.PackageQty')" width="80"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="manufactureDate" :title="$t('batchReceive.ManufactureDate')" width="100"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="expiryDate" :title="$t('batchReceive.ExpiryDate')" width="150"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="shelfDate" :title="$t('batchReceive.ShelfDate')" width="100"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="palletID" :title="$t('batchReceive.PalletID')" width="100"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="cartonID" :title="$t('batchReceive.CartonID')" width="100"></vxe-table-column>
            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import moment from 'moment';
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    export default {
        data () {
            return {
                searchTable: [],
                tableData: [],
                visible: false,
                dateFormat: 'YYYY-MM-DD', // 时间格式
                skuVal: '', // 模糊查询sku值
                statusValue: undefined, // 状态模糊查询值
                statusSelect: [], // 状态下拉数据
                completeData: [], // locationCode查询数据
                btnLoading: false, // 按钮加载
                tableLoading: false, // 表格加载
                emitUid: '', // 父表传过来的uid
            }
        },
        computed: {
            validRules(){ // 需要校验正则
                return  {
                    recDate: [
                        {required: true, message: this.$t('publicLang.Required')},
                    ],
                    locationCode: [
                        {required: true, message: this.$t('publicLang.Required')},
                    ],
                    recQty: [
                        {required: true, message: this.$t('publicLang.Required')},
                    ],
                    recBaseQty: [
                        {required: true, message: this.$t('publicLang.Required')},
                    ],
                }
            }
        },
        methods:{
            moment,
//            Rec Base Qty自动计算事件是赋值插件 XEUtils 用不了chang 事件
            recQtyChange(row){
                row.recBaseQty = row.recQty * row.packageQty
            },
//            RecBaseQty 计算
            recBaseQtymount(row){
                return  row.recQty * row.packageQty
            },
//            Damage Base Qty自动计算
            damageQtyChange(row){
                row.damageBaseQty =  row.damageQty * row.packageQty
            },
            damageBasQtymount(row){
                return row.damageQty * row.packageQty
            },
//            holdBaseQty 自动计算
            holdQtyChange(row){
                row.holdBaseQty = row.holdQty * row.packageQty
            },
            holdBaseQtymount(row){
                return row.holdQty * row.packageQty
            },
//            取消 关闭
            cancel(){
                this.visible = false
            },
//            表格查询
            SearchTableEvent(){
                let skuVal = this.skuVal
                let statusValue = this.statusValue
                let arr = []
                if(skuVal == '' && statusValue == undefined){
                    this.tableData = this.searchTable
                    return
                }
                this.searchTable.filter(item => {
                    if(statusValue != undefined){
                        if (item.sku.search(skuVal) != -1 && item.status == statusValue){
                            arr.push(item)
                        }
                    }else{
                        if (item.sku.search(skuVal) != -1 ){
                            arr.push(item)
                        }
                    }

                })
                this.tableData = arr
            },
//            locationCode 查询
            handleSearch(value){
                if(value.length < 4){
                    return
                }
                let params = {
                    whsCode: this.searchTable[0].whsCode,
                    keyword: value,
                }
                ajax.post(api.INVENTORYLOCATION,params).then(res=>{
                    this.completeData = res.data
                })
            },
            //            校验
            editSave(){
                this.$refs.editTableRive.validate((errMap) => {
                    if (!errMap){
                        let updateRecords = JSON.parse(JSON.stringify(this.$refs.editTableRive.getUpdateRecords()))
                        if(updateRecords.length > 0){
                            for (let i in updateRecords) {
                                if (updateRecords[i].recDate != null) {
                                    updateRecords[i].recDate = moment(updateRecords[i].recDate).format('YYYY-MM-DD')
                                }
                                if (updateRecords[i].manufactureDate != null) {
                                    updateRecords[i].manufactureDate = moment(updateRecords[i].manufactureDate).format('YYYY-MM-DD')
                                }
                                if (updateRecords[i].expiryDate != null) {
                                    updateRecords[i].expiryDate = moment(updateRecords[i].manufactureDate).format('YYYY-MM-DD')
                                }
                                if (updateRecords[i].recQty + updateRecords[i].damageQty + updateRecords[i].holdQty > updateRecords[i].asnQty) {
                                    this.$customMessage.warning(this.$t('batchReceive.NotAllowToOverReceive'));
                                    return
                                }
                                if (updateRecords[i].recBaseQty + updateRecords[i].damageBaseQty + updateRecords[i].holdbaseQty > updateRecords[i].asnBaseQty) {
                                    this.$customMessage.warning(this.$t('batchReceive.NotAllowToOverReceive'));
                                    return
                                }
                            }
                            this.btnLoading = true
                            ajax.post(api.RECBATCHEDITOR,{voList: updateRecords}).then(res=>{
                                this.btnLoading = false
                                if(res.code == 200){
                                    this.$message.success(res.msg);
                                    this.initTable()
                                }else{
                                    if(res.msg == 'NotAllowToOverReceive'){
                                        this.$customMessage.warning(this.$t('batchReceive.NotAllowToOverReceive'));
                                    }
                                }
                            })
                        }
                    }
                })
            },
//            显示
            show(uid){
                this.emitUid = uid
                this.visible = true
                this.initTable()
            },
//            table 数据
            initTable(){
                ajax.get(api.RECBATCHEDIORSTATUS).then(res=>{
                    this.statusSelect = res.data
                })
                this.tableLoading = true
                ajax.get(api.RECBATCHEDITOR,{uid: this.emitUid}).then(res=>{
                    if(res.code == 200){
                        for(let i in res.data){
                            res.data[i].recDate
                            if(res.data[i].recDate != null ){
                                res.data[i].recDate = moment(res.data[i].recDate, this.dateFormat)
                            }
                            if(res.data[i].manufactureDate != null){
                                res.data[i].manufactureDate = moment(res.data[i].manufactureDate, this.dateFormat)
                            }
                            if(res.data[i].expiryDate != null){
                                res.data[i].expiryDate = moment(res.data[i].expiryDate, this.dateFormat)
                            }
                        }
                        this.tableData = res.data
                        this.searchTable = res.data
                    }
                    this.tableLoading = false
                })
            }
        }
    }
</script>
<style lang="less">
    .vxe-table--tooltip-wrapper, .vxe-table--valid-error-wrapper{
        z-index: 9999
    }
</style>